export default [
  {
    key: "postDetail",
    label: "field.channel",
  },
  {
    key: "number",
    label: "field.number",
  },
  {
    key: "amount",
    label: "field.amount",
  },
  {
    key: "total",
    label: "field.total",
  },
  {
    key: "payoutAmount",
    label: "field.winLoss",
  },
];